import { APP_NAME } from '../config/branding';
export { APP_NAME };

export const SUPPORT_EMAIL = 'support@bahlus.com';
export const LEGAL_ENTITY = APP_NAME;
export const MIN_AGE_YEARS = 13;
export const CONTACT_MAX_FILE_BYTES = 5 * 1024 * 1024; // 5 MB + small buffer

/** Contact form categories — value is stored server-side; label is user-facing. */
export const CONTACT_CATEGORIES = [
  { value: 'general_support', label: 'General support' },
  { value: 'product_questions', label: 'Product questions' },
  { value: 'privacy_data', label: 'Privacy and data requests' },
  { value: 'copyright_trademark', label: 'Copyright or trademark notices' },
  { value: 'partnership', label: 'Partnership inquiries' },
  { value: 'safety', label: 'Safety reports' },
  { value: 'other', label: 'Others' },
];

export const DEFAULT_CONTACT_CATEGORY = 'general_support';

export function resolveContactCategory(value) {
  const raw = String(value || '').trim().toLowerCase();
  return CONTACT_CATEGORIES.some((item) => item.value === raw) ? raw : DEFAULT_CONTACT_CATEGORY;
}

export const LEGAL_DISCLAIMER =
  'These terms, policies, and documentation may be updated at any time without prior notice. ' +
  'Continued use of the service after changes are published constitutes your acceptance of the revised materials. ' +
  'Please review this page periodically for the latest information.';

export const LEGAL_LAST_UPDATED = 'June 27, 2026';

export const FUTURE_LANGUAGES = [
  { code: 'en', label: 'English', available: true },
  // { code: 'es', label: 'Español', available: false },
  // { code: 'fr', label: 'Français', available: false },
  // { code: 'de', label: 'Deutsch', available: false },
  // { code: 'hi', label: 'हिन्दी', available: false },
  // { code: 'ar', label: 'العربية', available: false },
];
